export enum EServicePaymentType {
  FREE = 'FREE',
  PAID = 'PAID',
}
